// Auto-generated by dev:dump-permissions - DO NOT EDIT MANUALLY
// Generated on: 2025-06-12 16:30:20

export const ADMINISTER = 'administer'
export const CHANGE_AFFILIATE_COMMISSION = 'change affiliate commission'
export const CHANGE_PARTNER_COMMISSION = 'change partner commission'
export const COMPLETE_ORDER = 'orders.complete'
export const DOWNLOAD_INVOICE = 'download-invoice'
export const MANAGE_AFFILIATES = 'users.affiliates'
export const MANAGE_PARTNERS = 'users.partners'
export const PARTNERS_COMMISSIONS = 'partners.commissions'
export const UPDATE_COMPANY_PRICES = 'update company prices'
export const VIEW_AFFILIATE_COMMISSION = 'view affiliate commission'
export const VIEW_DRIVERS_SCHEDULE = 'drivers.view_schedule'
export const VIEW_PARTNER_COMMISSION = 'view partner commission'
